
    <div class="card">
      <div class="card-body">
        <div class="col-12">
          <div class="row">
            @if (loading) {
            <div class="spinner-container">
              <ngx-spinner name="spinnerCargaDatos" bdOpacity=0.3bd
                Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
                <p style="color: white">{{message}}</p>
              </ngx-spinner>
            </div>
            }
            @else {
            <div class="col-8">
              <label class="col-form-label"><b>Mediciones de tanques</b></label>
              <table id="tabla" class="table table-sm table-striped table-hover header_fijo">
                <thead class="text-center">
                  <tr>
                    <th>Tanque</th>
                    @if(cierreRealizoContinuado.aeroplanta.obtieneTelemediciones) {
                      <th></th>
                    }
                    <th>Producto</th>
                    <th>Cant. Natural</th>
                    <th>Cant. 15°</th>
                    <th>Varillado(mm)</th>
                    <th>Temperatura</th>
                    <th>Densidad</th>
                  </tr>
                </thead>
                <tbody [formGroup]="tablaTanques">
                  @for (tanque of cierreRealizoContinuado.medicionesTanques; track tanque.codigoTanque; let i = $index) {
                  <tr class="text-center">
                    <td>{{tanque.nombreTanque}}
                      @if (tanque.esMedicionCintelink) {
                      <div class="medicionCintelink" style="font-size: .75em;">
                        Fecha y hora de medición Cintelink: {{tanque.fechaHoraMedicion | date: "d'/'MM'/'y' 'hh:mm a"}}
                      </div>
                      }
                    </td>
                    @if(cierreRealizoContinuado.aeroplanta.obtieneTelemediciones) {
                      <td>
                        <button ngbTooltip="Consultar telemedición" class="btn btn-small" (click)="actualizarTanqueCintelink(tanque.codigoTanque, i)">
                          @if (indexTanqueParaActualizar === i) {
                          <i class="spinner-border text-dark spinner-border-sm"></i>
                          } @else {
                          <i class="fa fa-refresh"></i>
                          }
                        </button>
                      </td>
                    }
                    <td>{{tanque.codigoProducto}}</td>
                    <td [ngClass]="{'medicionCintelink': tanque.esMedicionCintelink}">
                      {{tanque.desactivarTanque ? 0 : tanque.nivelNatural | number: '1.0-0'}}
                      @if (tanque.desactivarTanque) {
                      <div class="dialog-error alert-danger" role="alert">
                        Tanque {{tanque.nombreTanque}} inactivo - Niveles en Cero
                      </div>
                      }
                    </td>
                    <td [ngClass]="{'medicionCintelink': tanque.esMedicionCintelink}">
                      @if (tanque.roleStatus) {
                      <span class="spinner-border text-dark spinner-border-sm" role="status"></span>
                      }
                      {{tanque.desactivarTanque ? 0 : tanque.nivel | number: '1.0-0'}}
                    </td>
                    <td>
                      <input [ngClass]="{'medicionCintelink': tanque.esMedicionCintelink}" class="form-control" (keyup)="changeValue(i, 'varillado', $event)"
                        appOnlyDecimal
                        [value]="cierreRealizoContinuado.medicionesTanques[i].varillado" maxlength="10"
                        [disabled]="tanque.desactivarUI || tanque.desactivarTanque">
                    </td>
                    <td>
                      <input [ngClass]="{'medicionCintelink': tanque.esMedicionCintelink}" class="form-control" (keyup)="changeValue(i, 'temperatura', $event)"
                        appOnlyDecimal
                        [value]="cierreRealizoContinuado.medicionesTanques[i].temperatura"
                        [disabled]="tanque.desactivarUI || tanque.desactivarTanque">
                      @if (!validarTemperatura(cierreRealizoContinuado.medicionesTanques[i].temperatura)) {
                      <div class="alert alert-danger letra">
                        La temperatura no puede ser mayor a 100° ó menor a -50°.
                      </div>
                      }
                    </td>
                    <td>
                      <input class="form-control" (keyup)="changeValue(i, 'densidad', $event)"
                      (keypress)="formatDensidad($event, i)"
                      [value]="cierreRealizoContinuado.medicionesTanques[i].densidadString == null ? '' : cierreRealizoContinuado.medicionesTanques[i].densidadString" maxlength="10" 
                      [disabled]="tanque.desactivarUI || tanque.desactivarTanque">
                      @if (!validarDensidad(cierreRealizoContinuado.medicionesTanques[i])) {
                      <div class="alert alert-danger letra">
                        La densidad debe estar dentro del rango del producto. [{{productoSeleccionado?.densidadMin}}] - [{{productoSeleccionado?.densidadMax}}]
                      </div>
                      }
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="col-4">
              <label class="col-form-label"><b>Conteo de aeroespecialidades</b></label>
              @if (cierreRealizoContinuado.aeroespecialidades.length > 0) {
              <table style="width:100%" id="tabla" class="table table-sm table-bordered table-hover header_fijo">
                <thead class="text-center">
                  <tr>
                    <th>Codigo</th>
                    <th>Producto</th>
                    <th>Cantidad</th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  @for (aeroespecialidad of cierreRealizoContinuado.aeroespecialidades; track aeroespecialidad.codigoAeroespecialidad; let i = $index) {
                  <tr>
                    <td>{{aeroespecialidad.codigoAeroespecialidad}}</td>
                    <td>{{aeroespecialidad.nombreAeroespecialidad}}</td>
                    <td>
                      <input class="form-control" appOnlyNumber size="1"
                        (keyup)="changeValueAeroespecialidad(i, 'stock', $event)" [value]="aeroespecialidad.stock">
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              }
              @if (cierreRealizoContinuado.aeroespecialidades.length == 0) {
              <ngb-alert>No hay aeroespecialidades en la aeroplanta</ngb-alert>
              }
            </div>
            }
          </div>
        </div>
      </div>
  
      <div class="card-footer">
        <div class="float-end">
          <button class="btn btn-primary" type="button" (click)="confirmarDatos()"
            [disabled]="guardando">
            @if (!guardando) {
            <span>Cargar datos</span>
            } @else {
            <div class="d-flex align-items-center">
              <div class="spinner-border text-light spinner-border-sm" role="status"></div>
              <span>Cargando...</span>
            </div>
            }
          </button>
        </div>
      </div>
    </div>
